// Generated by python -m forge.cdek.export_status_vocabulary. Do not edit.
// forge/cdek/status_vocabulary.py is the single source of this vocabulary;
// run the exporter after changing it and commit the result.

export const CDEK_STATUS_LABELS = {
  accepted: 'Заказ принят СДЭК',
  accepted_in_recipient_city: 'Принят в городе получателя',
  accepted_in_transit_city: 'Принят в транзитном городе',
  at_pick_up_point: 'Готов к выдаче в пункте СДЭК',
  at_postamat: 'Готов к выдаче в постамате',
  at_recipient_warehouse: 'Принят на складе получателя',
  at_sender_warehouse: 'Принят на складе отправителя',
  at_transit_warehouse: 'Принят на транзитном складе',
  cancelled: 'Заказ СДЭК отменён',
  created: 'Готовится к отправке',
  delivered: 'Вручен',
  invalid: 'Заказ СДЭК недействителен',
  not_delivered: 'Не вручен',
  ready_in_sender_city: 'Готов к отправке из города отправителя',
  ready_in_transit_city: 'Готов к отправке из транзитного города',
  returned_to_recipient_city_warehouse: 'Не вручен · возвращён на склад доставки',
  returned_to_sender: 'Возвращён отправителю',
  returned_to_sender_city_warehouse: 'Возвращён на склад отправителя',
  sent_to_recipient_city: 'Отправлен в город получателя',
  sent_to_transit_city: 'Отправлен в транзитный город',
  taken_by_courier: 'Передан курьеру',
  taken_from_sender_city: 'Передан перевозчику в городе отправителя',
  taken_from_transit_city: 'Передан перевозчику в транзитном городе',
  unknown: 'Статус СДЭК обновлён',
} as const

export type CdekStatusLabelKey = keyof typeof CDEK_STATUS_LABELS

export const UNKNOWN_CDEK_STATUS_LABEL_KEY: CdekStatusLabelKey = 'unknown'

export type CdekShipmentState =
  | 'cancelled'
  | 'delivered'
  | 'delivery_issue'
  | 'in_transit'
  | 'out_for_delivery'
  | 'preparing'
  | 'ready_for_pickup'
  | 'returned'

export type CdekHandoffFact =
  | 'accepted_at_sender'
  | 'not_yet'
  | 'progressed'

export type CdekStatusLeg =
  | 'neutral'
  | 'toward_recipient'
  | 'toward_sender'

export type CdekStatusTerminality =
  | 'cancelled'
  | 'delivered'
  | 'open'
  | 'returned'

export type CdekStatusCode =
  | 'ACCEPTED'
  | 'ACCEPTED_AT_PICK_UP_POINT'
  | 'ACCEPTED_AT_POSTAMAT'
  | 'ACCEPTED_AT_RECIPIENT_CITY_WAREHOUSE'
  | 'ACCEPTED_AT_TRANSIT_WAREHOUSE'
  | 'ACCEPTED_IN_RECIPIENT_CITY'
  | 'ACCEPTED_IN_TRANSIT_CITY'
  | 'CANCELLED'
  | 'CREATED'
  | 'DELIVERED'
  | 'INVALID'
  | 'NOT_DELIVERED'
  | 'READY_FOR_SHIPMENT_IN_SENDER_CITY'
  | 'READY_FOR_SHIPMENT_IN_TRANSIT_CITY'
  | 'RECEIVED_AT_RECIPIENT_WAREHOUSE'
  | 'RECEIVED_AT_SENDER_WAREHOUSE'
  | 'RECEIVED_AT_SHIPMENT_WAREHOUSE'
  | 'RETURNED_TO_CLIENT'
  | 'RETURNED_TO_RECIPIENT_CITY_WAREHOUSE'
  | 'RETURNED_TO_SENDER'
  | 'RETURNED_TO_SENDER_CITY_WAREHOUSE'
  | 'SENT_TO_RECIPIENT_CITY'
  | 'SENT_TO_TRANSIT_CITY'
  | 'TAKEN_BY_COURIER'
  | 'TAKEN_BY_TRANSPORTER_FROM_SENDER_CITY'
  | 'TAKEN_BY_TRANSPORTER_FROM_TRANSIT_CITY'

export interface CdekStatusFacts {
  readonly stage: CdekShipmentState
  readonly handoff: CdekHandoffFact
  readonly leg: CdekStatusLeg
  readonly terminality: CdekStatusTerminality
  readonly proximity: number | null
  readonly labelKey: CdekStatusLabelKey
}

export const CDEK_STATUS_VOCABULARY: Readonly<
  Record<CdekStatusCode, CdekStatusFacts>
> = {
  ACCEPTED: {
    stage: 'preparing',
    handoff: 'not_yet',
    leg: 'neutral',
    terminality: 'open',
    proximity: 20,
    labelKey: 'accepted',
  },
  ACCEPTED_AT_PICK_UP_POINT: {
    stage: 'ready_for_pickup',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 96,
    labelKey: 'at_pick_up_point',
  },
  ACCEPTED_AT_POSTAMAT: {
    stage: 'ready_for_pickup',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 96,
    labelKey: 'at_postamat',
  },
  ACCEPTED_AT_RECIPIENT_CITY_WAREHOUSE: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 92,
    labelKey: 'at_recipient_warehouse',
  },
  ACCEPTED_AT_TRANSIT_WAREHOUSE: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 62,
    labelKey: 'at_transit_warehouse',
  },
  ACCEPTED_IN_RECIPIENT_CITY: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 90,
    labelKey: 'accepted_in_recipient_city',
  },
  ACCEPTED_IN_TRANSIT_CITY: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 60,
    labelKey: 'accepted_in_transit_city',
  },
  CANCELLED: {
    stage: 'cancelled',
    handoff: 'not_yet',
    leg: 'neutral',
    terminality: 'cancelled',
    proximity: null,
    labelKey: 'cancelled',
  },
  CREATED: {
    stage: 'preparing',
    handoff: 'not_yet',
    leg: 'neutral',
    terminality: 'open',
    proximity: 10,
    labelKey: 'created',
  },
  DELIVERED: {
    stage: 'delivered',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'delivered',
    proximity: null,
    labelKey: 'delivered',
  },
  INVALID: {
    stage: 'cancelled',
    handoff: 'not_yet',
    leg: 'neutral',
    terminality: 'cancelled',
    proximity: null,
    labelKey: 'invalid',
  },
  NOT_DELIVERED: {
    stage: 'delivery_issue',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: null,
    labelKey: 'not_delivered',
  },
  READY_FOR_SHIPMENT_IN_SENDER_CITY: {
    stage: 'preparing',
    handoff: 'accepted_at_sender',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 36,
    labelKey: 'ready_in_sender_city',
  },
  READY_FOR_SHIPMENT_IN_TRANSIT_CITY: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 66,
    labelKey: 'ready_in_transit_city',
  },
  RECEIVED_AT_RECIPIENT_WAREHOUSE: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 92,
    labelKey: 'at_recipient_warehouse',
  },
  RECEIVED_AT_SENDER_WAREHOUSE: {
    stage: 'in_transit',
    handoff: 'accepted_at_sender',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 32,
    labelKey: 'at_sender_warehouse',
  },
  RECEIVED_AT_SHIPMENT_WAREHOUSE: {
    stage: 'preparing',
    handoff: 'accepted_at_sender',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 32,
    labelKey: 'at_sender_warehouse',
  },
  RETURNED_TO_CLIENT: {
    stage: 'returned',
    handoff: 'progressed',
    leg: 'toward_sender',
    terminality: 'returned',
    proximity: null,
    labelKey: 'returned_to_sender',
  },
  RETURNED_TO_RECIPIENT_CITY_WAREHOUSE: {
    stage: 'delivery_issue',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: null,
    labelKey: 'returned_to_recipient_city_warehouse',
  },
  RETURNED_TO_SENDER: {
    stage: 'returned',
    handoff: 'progressed',
    leg: 'toward_sender',
    terminality: 'returned',
    proximity: null,
    labelKey: 'returned_to_sender',
  },
  RETURNED_TO_SENDER_CITY_WAREHOUSE: {
    stage: 'returned',
    handoff: 'progressed',
    leg: 'toward_sender',
    terminality: 'open',
    proximity: null,
    labelKey: 'returned_to_sender_city_warehouse',
  },
  SENT_TO_RECIPIENT_CITY: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 78,
    labelKey: 'sent_to_recipient_city',
  },
  SENT_TO_TRANSIT_CITY: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 55,
    labelKey: 'sent_to_transit_city',
  },
  TAKEN_BY_COURIER: {
    stage: 'out_for_delivery',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 100,
    labelKey: 'taken_by_courier',
  },
  TAKEN_BY_TRANSPORTER_FROM_SENDER_CITY: {
    stage: 'in_transit',
    handoff: 'accepted_at_sender',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 42,
    labelKey: 'taken_from_sender_city',
  },
  TAKEN_BY_TRANSPORTER_FROM_TRANSIT_CITY: {
    stage: 'in_transit',
    handoff: 'progressed',
    leg: 'toward_recipient',
    terminality: 'open',
    proximity: 70,
    labelKey: 'taken_from_transit_city',
  },
}

/** An unreviewed provider code classifies to null; it never borrows a stage. */
export function classifyCdekStatus(
  raw: string | null | undefined
): CdekStatusFacts | null {
  const code = (raw ?? '').trim().toUpperCase()
  return code in CDEK_STATUS_VOCABULARY
    ? CDEK_STATUS_VOCABULARY[code as CdekStatusCode]
    : null
}

export function cdekStatusLabel(
  labelKey: CdekStatusLabelKey,
  city?: string | null
): string {
  const text = CDEK_STATUS_LABELS[labelKey]
  const located = (city ?? '').trim()
  return located ? text + ' \u00b7 ' + located : text
}
